export default {
  date: 'for <b>Partner</b> commissions type - date of payment for a subscription issued using a partner link.',
  commission: 'Commissions earned for paid subscriptions within the Enhancify partnership program.<br>',
};
